export const NotificationTypes = [
    { id: 'SMS', name: 'SMS' },
    { id: 'EMAIL', name: 'EMAIL' },
    { id: 'PUSH', name: 'PUSH' },
  ];
  